'use strict';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * Fetch axios封装请求
 * DEV: guoxing
 * WIKI: http://wiki.corp.tujia.com/confluence/pages/viewpage.action?pageId=5327872
 */
import axios from 'axios';
/**
 * @description Fetch 封装。
 * @param [S] 为resHandle拦截器返回的数据类型。可不传
 */
var Fetch = /** @class */ (function () {
    /**
     * Fetch 构造器
     * @param {Function|undefined} reqHandle 请求拦截方法
     * @param {Function|undefined} resHandle 返回拦截方法
     */
    function Fetch(_a) {
        var _b = _a === void 0 ? {} : _a, reqHandle = _b.reqHandle, resHandle = _b.resHandle, ignoreErrorIntercept = _b.ignoreErrorIntercept;
        this.axios = axios.create();
        this.reqHandle = reqHandle;
        this.resHandle = resHandle;
        this.ignoreErrorIntercept = ignoreErrorIntercept;
        this.prepareSigner = null;
        this.cancelKey = '';
        this.httpRequestList = {};
    }
    /**
     * http 请求方法
     * 泛型 T 接口返回的默认数据
     * 泛型 R 接口返回的数据，可以经过拦截器封装 默认返回T
     * @param {AxiosRequestConfig} options 请求的参数
     */
    Fetch.prototype.http = function (options) {
        var _this = this;
        // 增加接口请求的timespan
        options.params = options.params || {};
        options.params._apitsp = new Date().getTime();
        // 如果发送请求前存在cancel key，则创建cancelToken
        if (this.cancelKey) {
            options.cancelToken = new axios.CancelToken(function (cancel) {
                _this.httpRequestList[_this.cancelKey] = cancel;
            });
            // 创建后及时清空
            this.cancelKey = '';
        }
        if (this.reqHandle) {
            this.reqHandle(options);
        }
        return this.axios(options)
            .then(function (res) {
            if (_this.resHandle) {
                return _this.resHandle(res.data, options);
            }
            return Promise.resolve(res.data);
        })
            .catch(function (err) {
            var reqErr = err;
            // -1 请求被取消
            if (axios.isCancel(err)) {
                reqErr = {
                    errorNo: -1,
                    errorMsg: "cancel",
                    httpStatus: 0
                };
            }
            if (err.response || err.request) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                var httpStatus = (err.response && err.response.status) || 0;
                var errorNo = 1000;
                if (err.response) {
                    // 1000: 正常请求异常 1001: 正常请求未知异常-可能为代码异常
                    errorNo = err.response.status > 0 ? 1000 : 1001;
                }
                else {
                    // -1000 网络问题
                    errorNo = -1000;
                }
                reqErr = {
                    errorNo: errorNo,
                    errorMsg: "\u7F51\u7EDC\u8BF7\u6C42\u9519\u8BEF: ".concat(err && err.message),
                    httpStatus: httpStatus
                };
            }
            // 错误提示
            console.error('HTTP-ERROR:', {
                url: options.url,
                httpStatus: reqErr.httpStatus || 0,
                err: reqErr,
                options: JSON.stringify(options)
            });
            if (_this.resHandle && !_this.ignoreErrorIntercept) {
                return _this.resHandle(reqErr, options);
            }
            return Promise.reject(reqErr);
        });
    };
    /**
     * Post请求
     * @param  {String} url                       请求URL
     * @param  {Object} data                      post请求数据
     * @param  {Object} [params]                  url参数
     * @param  {Object} headers                   header自定义
     * @param  {Boolean} [withCredentials=false]  设置是否跨域传输cookie
     * @param  {int} [timeout=10000}] 过时时间
     * @return {Promise}                          返回 http 方法  post 返回值
     */
    Fetch.prototype.post = function (url, _a) {
        var _b = _a === void 0 ? {} : _a, data = _b.data, params = _b.params, headers = _b.headers, _c = _b.withCredentials, withCredentials = _c === void 0 ? false : _c, _d = _b.timeout, timeout = _d === void 0 ? 10000 : _d;
        return this.http({
            url: url,
            method: 'post',
            data: data,
            params: params,
            headers: headers,
            withCredentials: withCredentials,
            timeout: timeout
        });
    };
    /**
     * Get请求
     * @param  {String} url                       请求URL
     * @param  {Object} [data]                      post请求数据
     * @param  {Object} params                    url参数
     * @param  {Object} headers                   header自定义
     * @param  {Boolean} [withCredentials=false]  设置是否跨域传输cookie
     * @param  {int} [timeout=10000}]             过时时间
     * @return {Promise}                          返回 http 方法 get 返回值
     */
    Fetch.prototype.get = function (url, _a) {
        var _b = _a === void 0 ? {} : _a, data = _b.data, params = _b.params, headers = _b.headers, _c = _b.withCredentials, withCredentials = _c === void 0 ? false : _c, _d = _b.timeout, timeout = _d === void 0 ? 10000 : _d;
        return this.http({
            url: url,
            method: 'get',
            data: data,
            params: params,
            headers: headers,
            withCredentials: withCredentials,
            timeout: timeout
        });
    };
    /**
     *
     * @param {string} url                        请求URL
     * @param {Object} data                       post请求数据
     * @param {Object} [params]                   url参数
     * @param {Object} [headers]                  header自定义
     * @param {Boolean} [withCredentials=false]   设置是否跨域传输cookie
     * @param {number} [timeout = 10000]          过时时间
     */
    Fetch.prototype.postWithSigner = function (url, _a) {
        var _b = _a === void 0 ? {} : _a, data = _b.data, params = _b.params, headers = _b.headers, _c = _b.withCredentials, withCredentials = _c === void 0 ? false : _c, _d = _b.timeout, timeout = _d === void 0 ? 10000 : _d;
        return __awaiter(this, void 0, void 0, function () {
            var sign, e_1;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        sign = null;
                        if (!this.prepareSigner) {
                            throw Error('Prepare Signer is undefined!');
                        }
                        if (data && typeof data === 'object') {
                            data = JSON.parse(JSON.stringify(data));
                        }
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.prepareSigner({ url: url, data: data })];
                    case 2:
                        sign = _e.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _e.sent();
                        window._fas &&
                            window._fas.setCustomError({
                                message: 'prepareSigner failed',
                                error: e_1 ? e_1.toString() : 'catch message is undefined'
                            });
                        return [2 /*return*/, {
                                isSuccess: false,
                                errorMsg: '网络请求错误，请稍后重试。-2001',
                                errorNo: 2001
                            }];
                    case 4: return [2 /*return*/, this.http({
                            url: url,
                            method: 'post',
                            data: data,
                            params: params,
                            headers: __assign(__assign({}, headers), sign),
                            withCredentials: withCredentials,
                            timeout: timeout
                        })];
                }
            });
        });
    };
    /**
     * 引入加签工具
     * @param {FetchPrepareSigner} prepareSigner  加签函数
     * @returns {void}
     */
    Fetch.prototype.setPrepareSigner = function (prepareSigner) {
        this.prepareSigner = prepareSigner;
    };
    /**
     * 设置当前请求的cancel key, 用于业务逻辑中手动取消请求
     * @param key cancel key
     */
    Fetch.prototype.setCancelToken = function (key) {
        this.cancelKey = key;
    };
    return Fetch;
}());
export default Fetch;
if (!Promise.prototype.finally) {
    Promise.prototype.finally = function (callback) {
        var P = this.constructor;
        return this.then(function (value) { return P.resolve(callback()).then(function () { return value; }); }, function (reason) {
            return P.resolve(callback()).then(function () {
                throw reason;
            });
        });
    };
}
